import axios from "axios";
import config from "../config";

export default {
  login: (email, password) => {
    return new Promise((resolve) => {
      axios.post(config.loginUserEndpoint, { email, password }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  addPendingUserClient: (creds) => {
    return new Promise((resolve) => {
      axios.post(config.addPendingUserEndpoint, creds).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  // updateUserData: (updates) => {
  //   return new Promise((resolve) => {
  //     axios.post(config.updateUserDataEndpoint, { updates }).then((serverRes) => {
  //       if (serverRes.data) return resolve(serverRes.data);
  //       resolve({ err: "Problem with the request" });
  //     });
  //   });
  // },

  tryConfEmailToken: (token, clientEmail) => {
    return new Promise((resolve) => {
      axios.post(config.confEmailEndpoint, { token, clientEmail }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        resolve({ err: "Problem with the request" });
      });
    });
  },

  resendEmailConf: (email) => {
    return new Promise((resolve) => {
      axios.post(config.resendEmailConfEndpoint, { email }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        return resolve({ err: "Problem with the request" });
      });
    });
  },

  resetUserPass: (email) => {
    return new Promise((resolve) => {
      axios.post(config.resetUserPassEndpoint, { email }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        return resolve({ err: "Problem with the request" });
      });
    });
  },

  changePass: (email, password, token) => {
    return new Promise((resolve) => {
      axios.post(config.changeUserPassEndpoint, { email, password, token }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        return resolve({ err: "Problem with the request" });
      });
    });
  },

  getNotifications: () => {
    return new Promise((resolve) => {
      axios.get(config.getNotificationsEndopint).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        return resolve({ err: "Problem with the request" });
      });
    });
  },

  rejectNotification: (dealId) => {
    return new Promise((resolve) => {
      axios.get(config.rejectNotificationEndpoint + "?dealId=" + dealId).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        return resolve({ err: "Problem with the request" });
      });
    });
  },

  approveNotificationEdits: (dealId, updates) => {
    return new Promise((resolve) => {
      axios.post(config.approveNotificationEditsEndpoint, { updates, dealId }).then((serverRes) => {
        if (serverRes.data) return resolve(serverRes.data);
        return resolve({ err: "Problem with the request" });
      });
    });
  },

  fixUtcFormat: (fullDate) => {
    if (fullDate instanceof Date) return fullDate;
    if (!config.apiUrlEndpoint.includes("localhost") && fullDate) fullDate = fullDate.replace("Z", "");
    return new Date(fullDate);
  }
};
